/** Semáforo verde/amarillo/rojo: verde si valor <= greenMax, amarillo si <= yellowMax, rojo si es mayor. */

const BACKGROUND_COLORS = {
  green: '#c8e6c9',
  yellow: '#fff9c4',
  red: '#ffcdd2',
};

const TEXT_COLORS = {
  green: '#2e7d32',
  yellow: '#f9a825',
  red: '#c62828',
};

export function isValidColorThresholds(ct) {
  if (!ct) return false;
  const green = Number(ct.greenMax);
  const yellow = Number(ct.yellowMax);
  return Number.isFinite(green) && Number.isFinite(yellow) && green <= yellow;
}

function bandFor(value, colorThresholds) {
  if (!isValidColorThresholds(colorThresholds)) return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value ?? '').trim());
  if (!Number.isFinite(n)) return null;
  const green = Number(colorThresholds.greenMax);
  const yellow = Number(colorThresholds.yellowMax);
  if (n <= green) return 'green';
  if (n <= yellow) return 'yellow';
  return 'red';
}

/** Color de fondo de celda (tipo Tabla) según el valor y los umbrales configurados. */
export function resolveThresholdBackground(value, colorThresholds) {
  const band = bandFor(value, colorThresholds);
  return band ? BACKGROUND_COLORS[band] : null;
}

/** Color de texto (tipo KPI) según el valor y los umbrales configurados. */
export function resolveThresholdTextColor(value, colorThresholds) {
  const band = bandFor(value, colorThresholds);
  return band ? TEXT_COLORS[band] : null;
}

const LABEL_KEY_BY_BAND = {
  green: 'greenLabel',
  yellow: 'yellowLabel',
  red: 'redLabel',
};

/** Etiqueta de texto (ej. "Normal"/"Alerta"/"Crítico") para la banda del valor, si se configuró. */
export function resolveThresholdLabel(value, colorThresholds) {
  const band = bandFor(value, colorThresholds);
  if (!band) return null;
  const label = colorThresholds?.[LABEL_KEY_BY_BAND[band]];
  return label && String(label).trim() ? String(label).trim() : null;
}
